export default __webpack_public_path__ + "08254b5424f690fb4d999ee7150bd61a.svg";